var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "top-comments-report",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _vm.fullScreen
        ? _c(
            "div",
            { staticClass: "title" },
            [
              _c("ChartDoddleIcon"),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.commentAnalysis")))]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.download") },
                      expression: "{ content: $t('report.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.fullScreen") },
                      expression: "{ content: $t('report.fullScreen') }",
                    },
                  ],
                  attrs: { onClick: _vm.switchToFullScreenMode },
                },
                [
                  !_vm.fullScreen
                    ? _c("md-icon", [_vm._v("fullscreen")])
                    : _c("md-icon", [_vm._v("fullscreen_exit")]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.data.topBestComments.length || _vm.data.topWorstComments.length
        ? _c("div", { staticClass: "tables" }, [
            _vm.data.topBestComments.length
              ? _c(
                  "div",
                  { staticClass: "table-wrapper table-top-best-comments" },
                  [
                    _c("div", { staticClass: "table-title" }, [
                      _c("i", { staticClass: "material-icons text-success" }, [
                        _vm._v("sentiment_very_satisfied"),
                      ]),
                      _vm._v(" "),
                      _c("h3", [
                        _vm._v(_vm._s(_vm.$t("report.topBestComments"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("ve-table", {
                      attrs: {
                        columns: _vm.getColumns(),
                        "table-data": _vm.data.topBestComments,
                        "row-style-option": _vm.rowStyleOption,
                        "border-x": true,
                        "border-y": true,
                        "row-key-field-name": "_id",
                        id: "comments-table",
                        "fixed-header": true,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.data.topWorstComments.length
              ? _c(
                  "div",
                  { staticClass: "table-wrapper table-top-worst-comments" },
                  [
                    _c("div", { staticClass: "table-title" }, [
                      _c("i", { staticClass: "material-icons text-danger" }, [
                        _vm._v("sentiment_very_dissatisfied"),
                      ]),
                      _vm._v(" "),
                      _c("h3", [
                        _vm._v(_vm._s(_vm.$t("report.topWorstComments"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("ve-table", {
                      attrs: {
                        columns: _vm.getColumns(),
                        "table-data": _vm.data.topWorstComments,
                        "row-style-option": _vm.rowStyleOption,
                        "border-x": true,
                        "border-y": true,
                        "row-key-field-name": "_id",
                        id: "comments-table",
                        "fixed-header": true,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _c("NoComment", { attrs: { title: _vm.$t("report.noComment") } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }